// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/** RentAll - Begin **/
.FaqSection-container-rfxSk {
	width: 100%;
	max-width: var(--max-container-width);
	margin: 0 auto;
	padding: 0 15px;
}
.FaqSection-seperator-oNK50 {
	background-color: var(--primary-foreground);
	width: 64px;
	display: block;
	height: 1.5px;
	margin: 0 auto;
	margin-bottom: 27px;
}
.FaqSection-boxseperator-ON8b7 {
	height: 2.5px;
	border: 1px solid var(--primary-foreground);
	background-color: transparent;
}
.FaqSection-mainhedding-ayNYE h1 {
	font-size: 46px;
	text-align: center;
	font-weight: bold;
	margin: 100px 0 60px;
	color: var(--primary-foreground);
}
h4.FaqSection-common-cTjER {
	font-size: 24px;
	font-weight: 800;
	margin-bottom: 20px;
}
p.FaqSection-common-cTjER {
	font-size: 17px;
	line-height: 1.7;
	font-weight: 400;
}
.FaqSection-faqsection-cyVmy {
	margin-bottom: 75px;
}
.FaqSection-faqsection-cyVmy p {
	font-size: 16px;
}
@media screen and (max-width: 991px) {
	h4.FaqSection-common-cTjER {
		font-size: 23px;
		font-weight: 600;
	}

	.FaqSection-mainhedding-ayNYE h1 {
		font-size: 36px;
		line-height: 51px;
		margin-bottom: 56px;
	}
}
@media screen and (max-width: 767px) {
	.FaqSection-mainhedding-ayNYE h1 {
		font-size: 24px;
		line-height: 30px;
		margin-bottom: 20px;
		text-align: left;
		padding-right: 15px;
		padding-left: 15px;
		margin: 50px 0;
	}

	h4.FaqSection-common-cTjER {
		font-size: 26px;
	}

	.FaqSection-faqsection-cyVmy {
		margin-bottom: 10px;
	}

	.FaqSection-faqsection-cyVmy {
		margin-bottom: 10px;
	}

	.FaqSection-faqsection-cyVmy p {
		padding-right: 10px;
	}
}`, "",{"version":3,"sources":["webpack://./src/components/WhyHost/FaqSection/FaqSection.css"],"names":[],"mappings":"AAAA,sBAAsB;AACtB;CACC,WAAW;CACX,qCAAqC;CACrC,cAAc;CACd,eAAe;AAChB;AAEA;CACC,2CAA2C;CAC3C,WAAW;CACX,cAAc;CACd,aAAa;CACb,cAAc;CACd,mBAAmB;AACpB;AAEA;CACC,aAAa;CACb,2CAA2C;CAC3C,6BAA6B;AAC9B;AAEA;CACC,eAAe;CACf,kBAAkB;CAClB,iBAAiB;CACjB,oBAAoB;CACpB,gCAAgC;AACjC;AAEA;CACC,eAAe;CACf,gBAAgB;CAChB,mBAAmB;AACpB;AAEA;CACC,eAAe;CACf,gBAAgB;CAChB,gBAAgB;AACjB;AAEA;CACC,mBAAmB;AACpB;AAEA;CACC,eAAe;AAChB;AAEA;CACC;EACC,eAAe;EACf,gBAAgB;CACjB;;CAEA;EACC,eAAe;EACf,iBAAiB;EACjB,mBAAmB;CACpB;AACD;AAEA;CACC;EACC,eAAe;EACf,iBAAiB;EACjB,mBAAmB;EACnB,gBAAgB;EAChB,mBAAmB;EACnB,kBAAkB;EAClB,cAAc;CACf;;CAEA;EACC,eAAe;CAChB;;CAEA;EACC,mBAAmB;CACpB;;CAEA;EACC,mBAAmB;CACpB;;CAEA;EACC,mBAAmB;CACpB;AACD","sourcesContent":["/** RentAll - Begin **/\n.container {\n\twidth: 100%;\n\tmax-width: var(--max-container-width);\n\tmargin: 0 auto;\n\tpadding: 0 15px;\n}\n\n.seperator {\n\tbackground-color: var(--primary-foreground);\n\twidth: 64px;\n\tdisplay: block;\n\theight: 1.5px;\n\tmargin: 0 auto;\n\tmargin-bottom: 27px;\n}\n\n.boxseperator {\n\theight: 2.5px;\n\tborder: 1px solid var(--primary-foreground);\n\tbackground-color: transparent;\n}\n\n.mainhedding h1 {\n\tfont-size: 46px;\n\ttext-align: center;\n\tfont-weight: bold;\n\tmargin: 100px 0 60px;\n\tcolor: var(--primary-foreground);\n}\n\nh4.common {\n\tfont-size: 24px;\n\tfont-weight: 800;\n\tmargin-bottom: 20px;\n}\n\np.common {\n\tfont-size: 17px;\n\tline-height: 1.7;\n\tfont-weight: 400;\n}\n\n.faqsection {\n\tmargin-bottom: 75px;\n}\n\n.faqsection p {\n\tfont-size: 16px;\n}\n\n@media screen and (max-width: 991px) {\n\th4.common {\n\t\tfont-size: 23px;\n\t\tfont-weight: 600;\n\t}\n\n\t.mainhedding h1 {\n\t\tfont-size: 36px;\n\t\tline-height: 51px;\n\t\tmargin-bottom: 56px;\n\t}\n}\n\n@media screen and (max-width: 767px) {\n\t.mainhedding h1 {\n\t\tfont-size: 24px;\n\t\tline-height: 30px;\n\t\tmargin-bottom: 20px;\n\t\ttext-align: left;\n\t\tpadding-right: 15px;\n\t\tpadding-left: 15px;\n\t\tmargin: 50px 0;\n\t}\n\n\th4.common {\n\t\tfont-size: 26px;\n\t}\n\n\t.faqsection {\n\t\tmargin-bottom: 10px;\n\t}\n\n\t.faqsection {\n\t\tmargin-bottom: 10px;\n\t}\n\n\t.faqsection p {\n\t\tpadding-right: 10px;\n\t}\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"container": `FaqSection-container-rfxSk`,
	"seperator": `FaqSection-seperator-oNK50`,
	"boxseperator": `FaqSection-boxseperator-ON8b7`,
	"mainhedding": `FaqSection-mainhedding-ayNYE`,
	"common": `FaqSection-common-cTjER`,
	"faqsection": `FaqSection-faqsection-cyVmy`
};
module.exports = ___CSS_LOADER_EXPORT___;
